import * as React from 'react';
import Box from "@mui/material/Box";
import {useState} from "react";
import LeadCounter from "./LeadCounter";
import LeadReport from "./LeadReport";
import GoodReport from "./GoodReport";
import {HorizontalMenu} from "../HorizontalMenu";
import css from "./Report.module.css";
import clsx from "clsx";
import dayjs from "dayjs";
import AreaReport from "./AreaReport";
import MenuConst from "../MenuConst";

export class ReportMenu{
    static NONE         = MenuConst.NONE;
    static AREA_REVIEW  = MenuConst.ADMIN_REPORT + 1;
    static LEADS_REVIEW = MenuConst.ADMIN_REPORT + 2;
    static LEADS_COUNT  = MenuConst.ADMIN_REPORT + 3;
    static GOODS        = MenuConst.ADMIN_REPORT + 4;

    static ITEMS = (()=> {
        let a = [];
        a[ReportMenu.AREA_REVIEW] = "Zasięgi";
        a[ReportMenu.LEADS_REVIEW] = "Leady przegląd";
        a[ReportMenu.LEADS_COUNT] = "Leady licznik";
        a[ReportMenu.GOODS] = "Dobra";
        return a;
    })();

    static admin = (()=> {
        let a = [];
        a[ReportMenu.AREA_REVIEW] = true;
        a[ReportMenu.LEADS_REVIEW] = true;
        a[ReportMenu.LEADS_COUNT] = true;
        a[ReportMenu.GOODS] = true;
        return a;
    })();

}

export default function Report(props) {
    const [activeTab, setActiveTab] = useState(ReportMenu.AREA_REVIEW);
    const [dateFrom, setDateFrom] = useState(props?.dateFrom ? props.dateFrom : dayjs(new Date()).add(-2, "month").toDate());
    const [dateTo, setDateTo] = useState(props?.dateTo ? props?.dateTo : new Date());

    return (
        <>
            {props.isAdmin && (
                <Box className={clsx(css.report)}>
                    <Box className={clsx(css.menu)}>
                        <HorizontalMenu
                            menuList={ReportMenu.ITEMS}
                            menuAdmin={ReportMenu.admin}
                            isAdmin={props.isAdmin}
                            setMenuIx={(index) => {
                                setActiveTab(index);
                            }}
                        />
                    </Box>

                    <Box className={clsx(css.child)}>
                        {activeTab === ReportMenu.AREA_REVIEW && <AreaReport dateFrom={dateFrom}
                                                                             dateTo={dateTo}
                                                                             auth={props.auth}/>}
                        {activeTab === ReportMenu.LEADS_REVIEW && <LeadReport dateFrom={dateFrom}
                                                                              dateTo={dateTo}
                                                                              auth={props.auth}/>}
                        {activeTab === ReportMenu.LEADS_COUNT && <LeadCounter dataFrom={dateFrom}
                                                                              dataTo={dateTo}
                                                                              auth={props.auth}/>}
                        {activeTab === ReportMenu.GOODS && <GoodReport dateFrom={dateFrom}
                                                                       dateTo={dateTo}
                                                                       auth={props.auth}/>}
                    </Box>
                </Box>
            )}
        </>
    );
}
